const chatMessagesData1 = [
  // {
  //   id: null,
  //   name: "Yesterday",
  //   type: "timeline",
  // },
  // {
  //   id: null,
  //   name: "Steven Franklin",
  //   message: "Hello!",
  //   time: "07/03/2025 10:00",
  //   type: "text",
  // },
  // {
  //   id: null,
  //   align: "right",
  //   name: "Henry Wells",
  //   message: "Hi, How are you? What about our next meeting?",
  //   time: "07/03/2025 10:02",
  //   type: "text",
  // },
  // {
  //   id: null,
  //   name: "Steven Franklin",
  //   message: "Yeah everything is fine",
  //   time: "07/03/2025 10:06",
  //   type: "text",
  // },
  // {
  //   id: null,
  //   align: "right",
  //   name: "Henry Wells",
  //   filename: "financial record.png",
  //   url: "https://stage.assets.101agent.eu/graph.png",
  //   time: "07/03/2025 10:06",
  //   type: "image",
  // },
  // {
  //   id: null,
  //   name: "Steven Franklin",
  //   message: "& Next meeting tomorrow 10.00AM",
  //   time: "07/03/2025 10:06",
  //   type: "text",
  // },
  // {
  //   id: null,
  //   align: "right",
  //   name: "Henry Wells",
  //   filename: "financial record.pdf",
  //   time: "07/03/2025 10:06",
  //   type: "file",
  // },
  // {
  //   id: null,
  //   align: "right",
  //   name: "Henry Wells",
  //   message: "Wow that's great",
  //   time: "07/03/2025 10:07",
  //   type: "text",
  // },
  // {
  //   id: null,
  //   name: "Today",
  //   type: "timeline",
  // },
  // {
  //   id: null,
  //   align: "right",
  //   url: "https://stage.assets.101agent.eu/test.mp3",
  //   time: "07/03/2025 10:07",
  //   type: "audio",
  // },
  {
    id: null,
    name: "Today",
    type: "timeline",
  },
  // {
  //   id: null,
  //   name: "Today",
  //   type: "waitaudio",
  // },
];

export { chatMessagesData1 };
